import * as React from 'react';
import { Button } from 'antd';
import { RouteComponentProps, withRouter, Link, Route } from 'react-router-dom';
import { connect } from 'react-redux'; // Connecting to Redux
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import Routes from "src/core/Routes";
import { withLocalize, Translate } from 'react-localize-redux';
import { PageProps } from 'src/models/common/ComponentProps';
import "./Parents.less";

interface RouteProps {
    gradeId: string;
}

interface ParentsHomeProps extends PageProps<RouteProps> {
}

class ParentsHome extends React.Component<ParentsHomeProps> {
    constructor(props: ParentsHomeProps) {
        super(props);
        bindAllOfThis(this, ParentsHome.prototype);
    }

    render() {
        return <div className="parents-portal">
            <h2><Translate id="public.parents.homeInstructions.header1" /></h2>
            <h3><Translate id="public.parents.homeInstructions.header2" /></h3>
            <p><Translate id="public.parents.homeInstructions.p1" /></p>
            <p><Translate id="public.parents.homeInstructions.p2" /></p>
            <p>
                <Translate id="public.parents.homeInstructions.p3.start" />
                <Link to={Routes.getRoute(Routes.PARENTS, 3)}>
                    <Translate id="public.parents.homeInstructions.p3.link" />
                </Link>
            </p>
            <p><Translate id="public.parents.homeInstructions.p4" /></p>
            <h3><Translate id="public.parents.homeInstructions.header3" /></h3>
            <p><Translate id="public.parents.homeInstructions.p5" /></p>


            <div>
                <Link to={Routes.getRoute(Routes.PARENTS, "PK")}>
                    <Translate id="public.parents.homeInstructions.gradeLinks.pk.avatar" />
                </Link>(<Translate id="public.parents.homeInstructions.gradeLinks.pk.level" />) - <Translate id="public.parents.homeInstructions.gradeLinks.pk.desc" />
            </div>
            <div>
                <Link to={Routes.getRoute(Routes.PARENTS, "K")}>
                    <Translate id="public.parents.homeInstructions.gradeLinks.k.avatar" />
                </Link>(<Translate id="public.parents.homeInstructions.gradeLinks.k.level" />) - <Translate id="public.parents.homeInstructions.gradeLinks.k.desc" />
            </div>
            <div>
                <Link to={Routes.getRoute(Routes.PARENTS, 1)}>
                    <Translate id="public.parents.homeInstructions.gradeLinks.1.avatar" />
                </Link>(<Translate id="public.parents.homeInstructions.gradeLinks.1.level" />) - <Translate id="public.parents.homeInstructions.gradeLinks.1.desc" />
            </div>
            <div>
                <Link to={Routes.getRoute(Routes.PARENTS, 2)}>
                    <Translate id="public.parents.homeInstructions.gradeLinks.2.avatar" />
                </Link> (<Translate id="public.parents.homeInstructions.gradeLinks.2.level" />) - <Translate id="public.parents.homeInstructions.gradeLinks.2.desc" />
            </div>

            <div>
                <Link to={Routes.getRoute(Routes.PARENTS, 3)}>
                    <Translate id="public.parents.homeInstructions.gradeLinks.3.avatar" />
                </Link> (<Translate id="public.parents.homeInstructions.gradeLinks.3.level" />) - <Translate id="public.parents.homeInstructions.gradeLinks.3.desc" />
            </div>
            <div>
                <Link to={Routes.getRoute(Routes.PARENTS, 4)}>
                    <Translate id="public.parents.homeInstructions.gradeLinks.4.avatar" />
                </Link> (<Translate id="public.parents.homeInstructions.gradeLinks.4.level" />) - <Translate id="public.parents.homeInstructions.gradeLinks.4.desc" />
            </div>
            <div>
                <Link to={Routes.getRoute(Routes.PARENTS, 5)}>
                    <Translate id="public.parents.homeInstructions.gradeLinks.5.avatar" />
                </Link> (<Translate id="public.parents.homeInstructions.gradeLinks.5.level" />) - <Translate id="public.parents.homeInstructions.gradeLinks.5.desc" />
            </div>
        </div>;
    }
}

export default ParentsHome;



// WEBPACK FOOTER //
// ./src/pages/public/ParentsHome.tsx